import { Injectable } from '@angular/core';

@Injectable()
export class DialogService {
  dialogReferences = {};

  constructor() {}

  public addDialog(key, template) {
    this.dialogReferences[key] = template;
  }

  public open(dialogName, config?) {
    return this.dialogReferences[dialogName].show(config);
  }
}
